import { Stack, StackDivider, Text } from '@chakra-ui/react';
import { Dinero, isZero } from 'dinero.js';
import * as React from 'react';

import { CurrencyDisplay } from '@/components/Currency';
import { Card } from '@/imports/ui/chakra/components/Card';

export const TicketOrderDetailsCard: React.FC<{
  ticketName: string;
  ticketPrice: Dinero<number>;
}> = (props) => {
  return (
    <Card p="6">
      <Stack spacing="4" divider={<StackDivider />}>
        <Stack>
          <Text
            textStyle="compactStrong"
            color="textSecondary.500"
            textTransform="uppercase"
          >
            Order Details
          </Text>
          <Stack spacing="0">
            <Text textStyle="bodyStrong">{props.ticketName}</Text>
            {isZero(props.ticketPrice) ? (
              <Text color="textSecondary.500">Free</Text>
            ) : (
              <CurrencyDisplay value={props.ticketPrice} color="textSecondary.500" />
            )}
          </Stack>
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Text textStyle="bodyStrong" color="textSecondary.500">
            Amount Due
          </Text>
          <CurrencyDisplay value={props.ticketPrice} textStyle="bodyStrong" />
        </Stack>
      </Stack>
    </Card>
  );
};
